import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  LOCALE_ID,
  signal,
  ViewChild
} from '@angular/core';
import { NgClass } from '@angular/common';

import { AuthState } from '@app/modules/users';
import { environment } from '@env';

import { LoginDialogButtonComponent } from '../../components/login-dialog-button/login-dialog-button.component';

const LOGIN_TELEGRAM = 'login_telegram';

@Component({
  selector: 'ui-dialog-login',
  templateUrl: './login.dialog.html',
  styleUrl: './login.dialog.scss',
  imports: [NgClass, LoginDialogButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginDialog {
  @ViewChild('telegramBtn', { static: false })
  public telegramBtn!: LoginDialogButtonComponent;

  private readonly authState = inject(AuthState);

  public readonly telegramData = this.authState.telegramData;
  public readonly localeId = inject(LOCALE_ID);
  public readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  public readonly showCisMethods = !environment.isEuDomain;
  public readonly steamAuthText = $localize`:@@login_dialog.login_through_steam:ВОЙТИ ЧЕРЕЗ STEAM`;
  public readonly tgAuthText = $localize`:@@login_dialog.login_through_telegram:ВОЙТИ ЧЕРЕЗ TELEGRAM`;
  public isAccountInfo = signal(false);
  public agreed = signal(!!localStorage.getItem(LOGIN_TELEGRAM));

  private readonly data = inject<{ redirectToMain?: boolean }>(DIALOG_DATA);
  public readonly redirectToMain = this.data?.redirectToMain;

  telegramClick(): void {
    if (!this.agreed()) {
      this.isAccountInfo.set(true);
    }
  }

  ok(): void {
    this.isAccountInfo.set(false);
    this.agreed.set(true);
    localStorage.setItem(LOGIN_TELEGRAM, 'true');
    // кнопки еще нет в шаблоне на момент клика
    setTimeout(() => {
      this.telegramBtn.redirectToAuth();
    });
  }
}
